import { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import RadioButtonGroup from 'components/molecules/radioButtonGroup/index.jsx';
import RadioButton from 'components/atoms/radioButton/index.jsx';
import Header from 'components/organisms/header/index.jsx';
import Button from 'components/atoms/button';
import validate from 'components/organisms/wizard/validate';
import Loader from 'components/atoms/loader';
import { fetchParameters } from 'actions/models';
import gmHome from 'resources/img/home_illustration_gm.svg';
import vwHome from 'resources/img/home_illustration_vw.svg';
import nissanHome from 'resources/img/home_illustration_nissan.svg';

import styles from './styles.scss';

class Home extends Component {
  componentDidMount() {
    this.props.fetchParameters(this.props.brandId);
  }

  render() {
    const { parameters, workshop, brand } = this.props;

    const containerStyle = styles[brand];

    return (
      <div className="home">
        <div className={containerStyle}>
          <Header />
          <section className="homeContent">
            <div className="container">
              <div className="col">
                <h3>
                  {brand === 'nissan' && 'Yacopini Nissan'}
                  {brand === 'gm' && 'Yacopini Motors'}
                  {brand === 'vw' && 'Yacopini Süd'}
                </h3>
                <h1>Turnos Online </h1>
                <p className="$1">
                  Bienvenido. Reservá un turno para realizar cualquier servicio que necesite tu
                  vehículo. Ingresá tus datos y elegí el día y el horario que mejor se ajuste a sus
                  posibilidades.
                </p>
                <br />
                <div className="workshops">
                  {this.props.isFetching && <Loader />}

                  {parameters && (
                    <RadioButtonGroup title="Elegí el taller más cercano:">
                      {parameters.workshops.map((workshop, i) => {
                        return (
                          <Field
                            key={i}
                            name="workshop"
                            component={RadioButton}
                            props={{ fieldValue: workshop, block: true }}
                          >
                            {workshop.name}
                          </Field>
                        );
                      })}
                    </RadioButtonGroup>
                  )}
                </div>
                <Button to="/pedido" buttonText="Empezar" disabled={!parameters || !workshop} />
                {brand === 'gm' && (
                  <div>
                    <br /><br />
                    <Button to="/siniestro" variant="secondary" buttonText="Reportar siniestro" />
                  </div>
                )}
              </div>
              <div className="col">
                <div className="image">
                  {brand === 'gm' && <img src={gmHome} alt="Turnos de taller Chevrolet" />}
                  {brand === 'vw' && <img src={vwHome} alt="Turnos de taller Volkswagen" />}
                  {brand === 'nissan' && <img src={nissanHome} alt="Turnos de taller Nissan" />}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

Home = reduxForm({
  form: 'shiftRequest',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(Home);

const selector = formValueSelector('shiftRequest');

Home = connect(state => {
  return {
    workshop: selector(state, 'workshop'),
  };
})(Home);

const mapStateToProps = state => {
  return {
    parameters: state.models.parameters,
    isFetching: state.models.isFetching,
    brand: state.configuration.brand,
    brandId: state.configuration.brand_id,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchParameters: brandId => {
      dispatch(fetchParameters(brandId));
    },
  };
};

Home = connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);

export default Home;
